import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
} from '@mui/material';
import LockIconWrapper from '../../../components/LockIconWrapper';

function PackageSelectionDialog({ open, onClose, availablePackages, onPackageSelect, participantCount = 0 }) {
  const getMinimumCount = pkg => {
    const value = Number(pkg?.upgrade?.minimumCount);
    return Number.isFinite(value) && value >= 0 ? Math.floor(value) : null;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <LockIconWrapper right={'internalBooking:update:own'}>Wähle ein Paket aus</LockIconWrapper>
      </DialogTitle>
      <DialogContent>
        {availablePackages && availablePackages.length > 0 ? (
          <List>
            {availablePackages.map(pkg => (
              <ListItemButton
                key={pkg.upgradeId}
                onClick={() => onPackageSelect(pkg.upgradeId)}
                disabled={
                  getMinimumCount(pkg) !== null && Number(participantCount || 0) < getMinimumCount(pkg)
                }
              >
                <ListItemText
                  primary={pkg.upgrade.name}
                  secondary={
                    getMinimumCount(pkg) !== null && Number(participantCount || 0) < getMinimumCount(pkg)
                      ? `Mindestens ${getMinimumCount(pkg)} Teilnehmer erforderlich`
                      : pkg.upgrade.descriptionShort
                  }
                />
              </ListItemButton>
            ))}
          </List>
        ) : (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant='body1' color='text.secondary'>
              Keine Pakete verfügbar
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
              Es sind derzeit keine Pakete verfügbar.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
      </DialogActions>
    </Dialog>
  );
}

export default PackageSelectionDialog;
